import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { RulesComponent } from './rules.component';

const routes: Routes = Route.withShell([
  { path: 'rules', component: RulesComponent, data: { title: 'Rules' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)],
  ],
  exports:[RouterModule],
  declarations: []
})
export class RulesRoutingModule { }
